import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WaitlistForm = ({ listType, cta, testPrefix, placeholder = "Deine E-Mail-Adresse" }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/waitlist/subscribe`, { email, list_type: listType });
      if (data.status === "already_confirmed") {
        toast.info(data.message);
      } else {
        setDone(true);
      }
    } catch {
      toast.error("Das hat leider nicht geklappt. Bitte prüfe deine E-Mail-Adresse.");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="flex items-start gap-3 card-soft !rounded-2xl p-5" data-testid={`${testPrefix}-success`}>
        <MailCheck size={22} style={{ color: "var(--gruen)" }} className="mt-0.5 shrink-0" />
        <p className="text-sm text-[color:var(--ink-muted)] leading-relaxed">
          <strong className="text-[color:var(--ink)]">Fast geschafft!</strong> Wir haben dir eine E-Mail geschickt.
          Bitte bestätige deine Anmeldung über den Link darin (Double-Opt-in).
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-md">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={placeholder}
        className="field flex-1"
        data-testid={`${testPrefix}-email-input`}
      />
      <button type="submit" className="btn-primary whitespace-nowrap" disabled={busy} data-testid={`${testPrefix}-submit-button`}>
        {busy ? "Wird gesendet…" : cta}
      </button>
    </form>
  );
};
